export enum ChannelSearchInputKeys {
  PetParentNames = 'petParentNames',
  PetNames = 'petNames',
  MessageBodies = 'messageBodies',
}

export interface ChannelSearchInput {
  [ChannelSearchInputKeys.PetParentNames]?: string;
  [ChannelSearchInputKeys.PetNames]?: string;
  [ChannelSearchInputKeys.MessageBodies]?: string;
}

export type ChannelSearchInputUpdates = { [key in keyof ChannelSearchInput]: string };
